module.exports = __webpack_public_path__ + "static/img/ikonaMuzykaDisabled-ON.74a000c1.png";